var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationDot = function SvgLocationDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F9",
    d: "M8.74 15.6C10.345 13.594 14 8.731 14 6c0-3.312-2.687-6-6-6-3.312 0-6 2.688-6 6 0 2.731 3.656 7.594 5.26 9.6a.944.944 0 0 0 1.48 0M8 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })));
};
export default SvgLocationDot;